















































































































































import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import { FEATURE_AGENTS_MATCH_BY_PRODUCT } from "@/constants";
import MultiLevelObject from "@/interfaces/MultiLevelObject";
import AgentCompanyAssociationDuplicateMixin, {
  AgentCompanyAssociationDuplicateMixinTags,
  AssociateManyIdSelectedPayload,
} from "@/mixins/http/Agents/AgentCompanyAssociationDuplicateMixin";
import { AgentModuleConfiguration, User } from "@/models";
import AdcontrolProfile from "@/models/AdcontrolProfile";
import ClientAgent from "@/models/Agents/Agent";
import AgentCompanyAssociationDuplicate from "@/models/Agents/AgentCompanyAssociationDuplicate";
import Media, { MEDIA_LABELS } from "@/models/Media";
import ToastInvoker from "@/utils/ToastInvoker";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { NotificationBadgeGroups } from "@/components/Agents/NotificationBadge.vue";

export type SelectionsPerMediaId = {
  [key: string]: string | null;
};

export type OptionsPerMediaId = {
  [key: string]: MultiLevelObject[];
};

@Component({
  components: { MultiLevelSelect },
})
export default class AgentCompanyAssociationDuplicatesAccordion extends Mixins(
  AgentCompanyAssociationDuplicateMixin
) {
  @Prop({ default: [] })
  readonly associations!: AgentCompanyAssociationDuplicate[];
  @Prop({ default: [] }) readonly agents!: ClientAgent[];
  @Prop({ default: {} })
  readonly agentModuleConfiguration!: AgentModuleConfiguration;
  @Prop({ default: [] }) readonly mediaIdsForDuplicates!: Array<number>;

  @Getter("profile") readonly profile!: AdcontrolProfile;
  @Getter("user") readonly user!: User;

  @Action("notificationsGroups/reload") readonly reloadNotificationForGroup!: (
    group: NotificationBadgeGroups
  ) => void;

  state: "opened" | "closed" = "closed";
  loading = false;
  visible = true;

  optionsPerMediaId: OptionsPerMediaId = {
    [Media.radio]: [],
    [Media.tv]: [],
  };

  selectionsPerMediaId: SelectionsPerMediaId = {
    [Media.radio]: null,
    [Media.tv]: null,
  };

  get hasMatchByProductFeature(): boolean {
    return (
      this.user.profile?.hasFeature(FEATURE_AGENTS_MATCH_BY_PRODUCT) ?? false
    );
  }

  get duplicatesGroupName(): string {
    const companyName = this.associations[0]?.agentCompany.name;
    const productName = this.associations[0]?.agentProduct?.name ?? "";

    if (productName) {
      return `${companyName} / ${productName}`;
    } else {
      return companyName;
    }
  }

  get agentCompanyAgentTypes(): string[] {
    return this.agentModuleConfiguration.agentCompanyAgentTypes;
  }

  get agencyAgentLabel(): string {
    return this.agentModuleConfiguration.agencyAgentConf.label;
  }

  getCellStyle(association: AgentCompanyAssociationDuplicate) {
    if (association.idSelected) {
      return "text-muted";
    }
    return "";
  }

  getIdSelected(association: AgentCompanyAssociationDuplicate) {
    return association.idSelected ?? "";
  }

  getAgencyId(association: AgentCompanyAssociationDuplicate) {
    return association.agency?.id ?? "";
  }

  getAgencyName(association: AgentCompanyAssociationDuplicate) {
    return association.agency?.name ?? "";
  }

  getAgencyAgentId(association: AgentCompanyAssociationDuplicate) {
    return association.agencyAgent?.id ?? "";
  }

  getAgencyAgentName(association: AgentCompanyAssociationDuplicate) {
    return association.agencyAgent?.name ?? "";
  }

  getCompanyId(association: AgentCompanyAssociationDuplicate) {
    return association.agentCompany?.id ?? "";
  }

  getCompanyName(association: AgentCompanyAssociationDuplicate) {
    return association?.agentCompany?.term || association?.agentCompany?.name;
  }

  getProductId(association: AgentCompanyAssociationDuplicate): string {
    return association.agentProduct?.id ?? "";
  }

  getProductName(association: AgentCompanyAssociationDuplicate): string {
    return association.agentProduct?.name ?? "";
  }

  getAgentCompanyAgentIdByType(
    association: AgentCompanyAssociationDuplicate,
    agentType: string
  ): string | null | undefined {
    return association.agentCompanyAgents.find(
      (agent) => agent.agentType === agentType
    )?.agentCode;
  }

  getAgentCompanyAgentNameByType(
    association: AgentCompanyAssociationDuplicate,
    agentType: string
  ): string | null | undefined {
    const agentFromDuplicate = association.agentCompanyAgents.find(
      (agent) => agent.agentType === agentType
    );

    return this.agents.find(
      (agent) => agent.id === agentFromDuplicate?.agentCode
    )?.name;
  }

  getAgentCompanyLabelByType(agentType: string): string {
    return (
      this.agentModuleConfiguration.getAgentCompanyAgentConfByType(agentType)
        ?.label || ""
    );
  }

  getMediaIconBasedOnMediaId(mediaId: string | number): string {
    switch (mediaId.toString()) {
      case Media.radio:
        return "radio";
      case Media.tv:
        return "tv";
      default:
        return "";
    }
  }

  selectedPlaceholderBasedOnMediaId(mediaId: string | number): string {
    return `Seleziona valore ${MEDIA_LABELS[mediaId]}`;
  }

  async toggleState() {
    if (this.state === "opened") {
      this.state = "closed";
      return;
    }

    this.selectionsPerMediaId = { [Media.radio]: null, [Media.tv]: null };
    this.mediaIdsForDuplicates.forEach((mediaId) => {
      this.optionsPerMediaId[mediaId] = this.associations
        .filter((association) => association.mediaId === mediaId)
        .map((association: AgentCompanyAssociationDuplicate) => {
          return {
            text: association.id,
            id: association.id,
          };
        });
    });
    this.state = "opened";
  }

  getOptionsBasedOnMediaId(mediaId: string): MultiLevelObject[] {
    return this.optionsPerMediaId[mediaId];
  }

  getSelectedIdByMediaId(mediaId: string): string | null {
    return this.selectionsPerMediaId[mediaId];
  }

  onDuplicateSelected(selectedId: MultiLevelObject, mediaId: string): void {
    this.selectionsPerMediaId[mediaId] = selectedId.id;
  }

  async onSave() {
    this.loading = true;

    const payload: AssociateManyIdSelectedPayload[] =
      this.mediaIdsForDuplicates.map((mediaId) => {
        return {
          selectedId: this.selectionsPerMediaId[mediaId] || "",
          targetIds: this.associations
            .filter((association) => association.mediaId === mediaId)
            .map((association) => association.id),
        };
      });

    try {
      const duplicates = await this.associateManyIdSelected(
        this.profile.slug,
        AgentCompanyAssociationDuplicateMixinTags.AssociateManyIdSelected,
        payload
      );
      this.$emit("saved", duplicates);
      this.visible = false;
      ToastInvoker.successToast("Salvataggio effettuato con successo");
      this.reloadNotificationForGroup(
        NotificationBadgeGroups.CompanyAssociationDuplicates
      );
    } catch (error) {
      ToastInvoker.errorToast("Errore durante il salvataggio!", null);
    } finally {
      this.loading = false;
    }
  }
}
